import useApi from "./useApi";

const useDatabase = () => {
  const {
    selectTable,
    selectTableByOrderId,
    selectTableByTrackingCode,
    updateTable,
    insertTable,
    deleteTable,
    bulkInsertTable,
    loading,
  } = useApi();

  const getCollection = async (collectionName: string) => {
    return await selectTable(collectionName);
  };

  const getCollectionByOrderId = async (collectionName: string, orderId: string) => {
    return await selectTableByOrderId(collectionName, orderId);
  };

  const getCollectionByTrackingCode = async (collectionName: string, trackingCode: string) => {
    return await selectTableByTrackingCode(collectionName, trackingCode);
  };

  const addCollection = async (collectionName: string, data: any) => {
    return await insertTable(collectionName, data);
  };

  const updateCollection = async (collectionName: string, data: any) => {
    return await updateTable(collectionName, data);
  };

  const deleteCollection = async (collectionName: string, id: string) => {
    return await deleteTable(collectionName, { id });
  };

  const bulkAddCollection = async (collectionName: string, data: any) => {
    return await bulkInsertTable(collectionName, data);
  };

  return {
    loading,
    addCollection,
    getCollection,
    getCollectionByOrderId,
    getCollectionByTrackingCode,
    updateCollection,
    deleteCollection,
    bulkAddCollection,
  };
};

export default useDatabase;
